import { useLocation } from 'react-router';

import { useTranslation } from 'app/lang';

import { accessTimePeriodForSports, isFinishedSportMatch } from '../../betting/accessMatchDetails';
import {
  RecordOfMatchEntity,
  SoccerPeriodType,
} from '../../betting/betting-entities';
import { SportId } from '../../betting/constants';
import { getFinishedPeriod } from '../get-finished-period';
import { SoccerKeyPeriod } from './constants';

import dictionary from './Soccer.dictionary.json';

const FIRST_TIME = 1;
const SECOND_TIME = 2;

export const SoccerPeriods = (
  sportId?: SportId,
  periods?: RecordOfMatchEntity['periods'],
) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isResults = pathname.includes('results');

  if (isResults || isFinishedSportMatch(sportId, periods)) {
    return getFinishedPeriod(SoccerKeyPeriod.FINISHED, t);
  }

  const timeBreakPeriod = periods?.get(SoccerPeriodType.BREAK, null);

  if (timeBreakPeriod?.get('number') === FIRST_TIME) {
    return {
      key: SoccerKeyPeriod.FIRST_TIME_BREAK,
      value: t(dictionary.firstTimeBreak),
    };
  }

  if (timeBreakPeriod?.get('number') === SECOND_TIME && !timeBreakPeriod?.get('finished')) {
    return {
      key: SoccerKeyPeriod.SECOND_TIME_BREAK,
      value: t(dictionary.secondTimeBreak),
    };
  }

  const extraTimePeriod = periods?.get(SoccerPeriodType.EXTRA_TIME, null);

  if (extraTimePeriod?.finished && extraTimePeriod.number === FIRST_TIME) {
    return {
      key: SoccerKeyPeriod.OVER_TIME_BREAK,
      value: t(dictionary.overTimeBreak),
    };
  }

  const penaltyPeriod = periods?.get(SoccerPeriodType.PENALTY, null);

  if (penaltyPeriod !== null) {
    return {
      key: SoccerKeyPeriod.PENALTY,
      value: t(dictionary.penaltyPeriod),
    };
  }

  const timePeriod = accessTimePeriodForSports(sportId, periods) || 0;
  const overtime = typeof extraTimePeriod?.number === 'number'
    ? t(dictionary.extraTimePeriod, { extraTimePeriod: extraTimePeriod.number })
    : null;

  const period = timePeriod !== null
    ? t(dictionary.timePeriod, { timePeriod })
    : null;

  return {
    key: SoccerKeyPeriod.OVERTIME_AND_PERIOD,
    value: {
      overtime,
      period,
    },
  };
};
